import type { IconProps } from '../types/icon-props';

export const ZoomitTrophy = (props: IconProps) => {
  const { ...rest } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 104" {...rest}>
      <defs>
        <linearGradient x1="40.948%" y1="57.58%" x2="54.992%" y2="45.749%" id="a71nq3v8ra">
          <stop stop-color="#FBC56D" offset="0%" />
          <stop stop-color="#C5715A" offset="100%" />
        </linearGradient>
        <linearGradient x1="32.231%" y1="61.456%" x2="73.131%" y2="35.155%" id="yzqikjp28b">
          <stop stop-color="#FBC56D" offset="0%" />
          <stop stop-color="#C5715A" offset="100%" />
        </linearGradient>
        <linearGradient x1="56.911%" y1="42.84%" x2="40.241%" y2="60.204%" id="5s9bqkja0c">
          <stop stop-color="#8C3D27" stop-opacity="0" offset="0%" />
          <stop stop-color="#8C3D27" offset="100%" />
        </linearGradient>
        <linearGradient x1="50.057%" y1="-.474%" x2="50.058%" y2="90.918%" id="6nwmvkq1hd">
          <stop stop-color="#FFDFCF" offset="0%" />
          <stop stop-color="#FFA78F" offset="100%" />
        </linearGradient>
        <linearGradient x1="82.703%" y1="-1.4%" x2="33.773%" y2="87.667%" id="wx1msrmz0e">
          <stop stop-color="#FFDFCF" offset="0%" />
          <stop stop-color="#FFA78F" offset="100%" />
        </linearGradient>
        <linearGradient x1="46.843%" y1="58.33%" x2="58.718%" y2="46.491%" id="w047ig1h6f">
          <stop stop-color="#F89580" stop-opacity="0" offset="0%" />
          <stop stop-color="#C5715A" offset="99.7%" />
        </linearGradient>
        <linearGradient x1="15.083%" y1="73.209%" x2="39.782%" y2="50.265%" id="c5qrc4hzpg">
          <stop stop-color="#FEF0AE" offset="0%" />
          <stop stop-color="#FBC56D" offset="100%" />
        </linearGradient>
        <linearGradient x1="47.37%" y1="71.852%" x2="74.866%" y2="44.346%" id="rsfvgl7t8h">
          <stop stop-color="#FEF0AE" offset="0%" />
          <stop stop-color="#FBC56D" offset="100%" />
        </linearGradient>
        <linearGradient x1="44.763%" y1="44.614%" x2="35.772%" y2="34.446%" id="pref8iow2i">
          <stop stop-color="#F6A96C" stop-opacity="0" offset="0%" />
          <stop stop-color="#F6A96C" stop-opacity=".996" offset="99.6%" />
          <stop stop-color="#F6A96C" offset="100%" />
        </linearGradient>
        <linearGradient x1="58.359%" y1="58.355%" x2="91.41%" y2="91.422%" id="7msaikyvzj">
          <stop stop-color="#DC8758" stop-opacity="0" offset="0%" />
          <stop stop-color="#DC8758" stop-opacity=".996" offset="99.6%" />
          <stop stop-color="#DC8758" offset="100%" />
        </linearGradient>
        <linearGradient x1="36.036%" y1="36.025%" x2="55.651%" y2="55.647%" id="p4puhq4rjk">
          <stop stop-color="#DC8758" stop-opacity="0" offset="0%" />
          <stop stop-color="#DC8758" stop-opacity=".996" offset="99.6%" />
          <stop stop-color="#DC8758" offset="100%" />
        </linearGradient>
        <linearGradient x1="30.077%" y1="33.713%" x2="66.649%" y2="61.169%" id="265or65fpl">
          <stop stop-color="#5A5A5A" offset="0%" />
          <stop stop-color="#444" offset="100%" />
        </linearGradient>
        <linearGradient x1="51.576%" y1="51.686%" x2="63.715%" y2="63.829%" id="1koo795x8m">
          <stop stop-color="#433F43" stop-opacity="0" offset="0%" />
          <stop stop-color="#1A1A1A" offset="100%" />
        </linearGradient>
        <linearGradient x1="55.492%" y1="44.594%" x2="46.359%" y2="53.729%" id="xxyaydcjbn">
          <stop stop-color="#F89580" stop-opacity="0" offset="0%" />
          <stop stop-color="#C5715A" offset="99.7%" />
        </linearGradient>
        <linearGradient x1="50.003%" y1="54.119%" x2="50.003%" y2="111.671%" id="aq30w4fj9o">
          <stop stop-color="#FD4755" offset="0%" />
          <stop stop-color="#A72B2B" offset="100%" />
        </linearGradient>
        <linearGradient x1="52.135%" y1="51.87%" x2="86.304%" y2="60.22%" id="5y69s6g59p">
          <stop stop-color="#F89580" stop-opacity="0" offset="0%" />
          <stop stop-color="#C5715A" offset="99.7%" />
        </linearGradient>
        <linearGradient x1="50.099%" y1="-36.358%" x2="50.099%" y2="166.783%" id="it2waa6nvq">
          <stop stop-color="#FFDFCF" offset="0%" />
          <stop stop-color="#FFA78F" offset="100%" />
        </linearGradient>
        <linearGradient x1="29.872%" y1="29.403%" x2="76.045%" y2="75.718%" id="eqk8ajwddr">
          <stop stop-color="#FFDFCF" offset="0%" />
          <stop stop-color="#FFA78F" offset="100%" />
        </linearGradient>
        <linearGradient x1="31.048%" y1="40.061%" x2="83.004%" y2="76.145%" id="nhw3pzvlms">
          <stop stop-color="#FFDFCF" offset="0%" />
          <stop stop-color="#FFA78F" offset="100%" />
        </linearGradient>
        <linearGradient x1="31.725%" y1="31.311%" x2="73.72%" y2="73.377%" id="lghl1bbhjt">
          <stop stop-color="#FFDFCF" offset="0%" />
          <stop stop-color="#FFA78F" offset="100%" />
        </linearGradient>
        <linearGradient x1="62.98%" y1="28.467%" x2="15.369%" y2="105.652%" id="oe574fwwfu">
          <stop stop-color="#FFDFCF" offset="0%" />
          <stop stop-color="#FFA78F" offset="100%" />
        </linearGradient>
      </defs>
      <g fill-rule="nonzero" fill="none">
        <path
          d="M37.95 68.81c-1.888 1.89-4.873 2.926-8.61 2.926-4.406 0-9.463-1.422-14.215-4.002C4.85 62.128-.654 53.07 2.595 47.118c1.625-3.006 5.159-4.65 9.91-4.65 4.407 0 9.464 1.42 14.216 4 10.275 5.606 15.799 14.645 12.55 20.616-.366.63-.792 1.22-1.32 1.727zM6.11 47.587c-.305.304-.569.65-.772 1.015-2.335 4.266 2.843 11.76 11.291 16.371 4.305 2.336 8.813 3.636 12.712 3.615 3.554 0 6.093-1.076 7.149-3.026 2.335-4.265-2.844-11.76-11.291-16.37-4.305-2.337-8.814-3.637-12.713-3.616-2.863.02-5.077.71-6.376 2.01z"
          fill="url(#a71nq3v8ra)"
        />
        <path
          d="M67.051 39.258c-5.97 3.25-15.007-2.275-20.612-12.552-2.579-4.753-4-9.79-4-14.218 0-4.753 1.665-8.267 4.65-9.912C53.059-.674 62.096 4.85 67.7 15.128c2.579 4.753 4.02 9.81 4 14.218 0 3.737-1.035 6.703-2.924 8.612a6.43 6.43 0 0 1-1.726 1.3zm-21.485-26.75c0 3.9 1.28 8.409 3.615 12.715 4.589 8.45 12.082 13.629 16.367 11.293 1.95-1.056 3.026-3.595 3.026-7.15 0-3.9-1.28-8.408-3.615-12.714-4.59-8.45-12.083-13.63-16.367-11.294-.366.204-.711.468-1.016.772-1.3 1.28-1.99 3.494-2.01 6.378z"
          fill="url(#yzqikjp28b)"
        />
        <path
          d="M67.051 39.258c-5.97 3.25-15.007-2.275-20.612-12.552-2.579-4.753-4-9.79-4-14.218 0-4.753 1.665-8.267 4.65-9.912C53.059-.674 62.096 4.85 67.7 15.128c2.579 4.753 4.02 9.81 4 14.218 0 3.737-1.035 6.703-2.924 8.612a6.43 6.43 0 0 1-1.726 1.3zm-21.485-26.75c0 3.9 1.28 8.409 3.615 12.715 4.589 8.45 12.082 13.629 16.367 11.293 1.95-1.056 3.026-3.595 3.026-7.15 0-3.9-1.28-8.408-3.615-12.714-4.59-8.45-12.083-13.63-16.367-11.294-.366.204-.711.468-1.016.772-1.3 1.28-1.99 3.494-2.01 6.378z"
          fill="url(#5s9bqkja0c)"
        />
        <path
          d="m57.324 52.907-13.748 13.75a11.35 11.35 0 0 0-3.209 6.399l-7.554 7.556a2.832 2.832 0 0 0 0 4.021l14.317 14.32a2.831 2.831 0 0 0 4.02 0l3.98-3.981a5.713 5.713 0 0 1 4.164-1.666 13.165 13.165 0 0 0 9.646-3.859l12.448-12.45-24.064-24.09z"
          fill="url(#6nwmvkq1hd)"
        />
        <path
          d="M61.873 70.558a18.737 18.737 0 0 0-11.352-5.403l-2.051 2.051a16.611 16.611 0 0 0-4.732 9.689l-.65 5.28c.163.183.325.346.488.529l6.762 6.763c4.59 4.59 11.697 5.078 16.835 1.503 4.224-7.23.873-14.238-5.3-20.412z"
          fill="url(#wx1msrmz0e)"
        />
        <path
          d="M78.992 79.413 68.96 89.447a13.133 13.133 0 0 1-9.646 3.86 5.68 5.68 0 0 0-4.163 1.665l-3.98 3.98a2.831 2.831 0 0 1-4.021 0L32.833 84.634c-1.117-1.117-1.117-2.925 0-4.021l7.555-7.556a11.348 11.348 0 0 1 3.208-6.398l13.748-13.75 18.074 18.076 3.614-3.615-.04 12.044z"
          fill="url(#w047ig1h6f)"
        />
        <path
          d="M90.587 71.086a14.383 14.383 0 0 0-4.935-1.26c-2.802-.223-5.442-1.38-7.432-3.371L63.558 51.79 51.78 63.57l14.662 14.665c1.99 1.99 3.147 4.631 3.37 7.434a14.39 14.39 0 0 0 1.26 4.936l19.515-19.52z"
          fill="url(#c5qrc4hzpg)"
        />
        <path
          d="M1.926 31.702c-2.64 2.64-2.56 6.967.203 9.486C25.868 62.819 51.88 72.162 62.015 62.027c10.133-10.135.812-36.154-20.836-59.898-2.518-2.762-6.843-2.844-9.483-.203L1.926 31.702z"
          fill="url(#rsfvgl7t8h)"
        />
        <path
          d="M31.696 1.926 1.926 31.702c-2.64 2.64-2.56 6.967.203 9.486a138.8 138.8 0 0 0 6.701 5.748L46.926 8.832a138.813 138.813 0 0 0-5.747-6.703c-2.518-2.762-6.843-2.844-9.483-.203z"
          fill="url(#pref8iow2i)"
        />
        <path
          d="M17.054 53.009c18.927 12.836 36.92 17.04 44.94 8.998 8.022-8.044 3.859-25.999-8.996-44.95L17.054 53.01z"
          fill="url(#7msaikyvzj)"
        />
        <path
          d="M69.813 85.67a14.39 14.39 0 0 0 1.259 4.935l19.515-19.52a14.383 14.383 0 0 0-4.935-1.259 11.738 11.738 0 0 1-4.223-1.117L68.696 81.444a11.744 11.744 0 0 1 1.117 4.225z"
          fill="url(#p4puhq4rjk)"
        />
        <path
          d="m103.442 79.25-24.207 24.212a1.84 1.84 0 0 1-2.233.284l-7.29-4.326a6.112 6.112 0 0 1-2.945-4.489 6.048 6.048 0 0 1 1.746-5.078l21.282-21.286a6.108 6.108 0 0 1 5.077-1.747 6.055 6.055 0 0 1 4.488 2.945l4.325 7.292c.447.69.346 1.605-.243 2.194z"
          fill="url(#265or65fpl)"
        />
        <path
          d="m69.732 99.4 7.29 4.326c.71.426 1.624.305 2.234-.284l24.206-24.211c.589-.59.71-1.504.284-2.235l-4.325-7.291a5.991 5.991 0 0 0-1.36-1.585L68.147 98.04a5.99 5.99 0 0 0 1.584 1.36z"
          fill="url(#1koo795x8m)"
        />
        <path
          d="m36.61 76.793-3.797 3.798a2.832 2.832 0 0 0 0 4.022l14.317 14.32a2.831 2.831 0 0 0 4.02 0l3.798-3.799-18.338-18.34z"
          fill="url(#xxyaydcjbn)"
        />
        <path
          d="M55.03 98.303 32.995 77.748c-1.381-1.28-3.33-1.077-4.488.02L7.266 98.993c-1.848 1.849-.528 4.997 2.072 4.997h43.457c2.965 0 4.407-3.656 2.234-5.687z"
          fill="url(#aq30w4fj9o)"
        />
        <path
          d="M52.45 85.71a4.093 4.093 0 0 1-5.828 0l-3.534-3.534c-5.686-5.708-6.234-14.604-1.604-20.92l5.382 2.111a13.396 13.396 0 0 1 5.523 3.331c5.199 5.18 5.28 13.65.183 18.91-.061.04-.102.061-.122.102z"
          fill="url(#5y69s6g59p)"
        />
        <path
          d="M84.698 67.552a4.266 4.266 0 0 0-5.97.06l-5.422 5.444a4.265 4.265 0 1 0 6.031 6.032l5.361-5.362c1.686-1.706 1.726-4.509 0-6.174z"
          fill="url(#it2waa6nvq)"
        />
        <path
          d="m78.992 67.369-5.686 5.687a4.265 4.265 0 1 1-6.032-6.033l5.747-5.748a4.266 4.266 0 0 1 5.97-.06c1.706 1.665 1.686 4.468 0 6.154z"
          fill="url(#eqk8ajwddr)"
        />
        <path
          d="m67.924 54.329-4.59 4.59-.812-.812a7.353 7.353 0 0 0-10.417 0l9.788-9.79a4.265 4.265 0 0 1 6.031 0c1.665 1.645 1.665 4.346 0 6.012z"
          fill="url(#nhw3pzvlms)"
        />
        <path
          d="m74.423 59.894-7.149 7.13a4.265 4.265 0 1 1-6.03-6.033l7.188-7.19a4.266 4.266 0 0 1 5.97-.061c1.726 1.665 1.706 4.448.02 6.154z"
          fill="url(#lghl1bbhjt)"
        />
        <path
          d="m68.899 64.485-10.6-10.603a6.875 6.875 0 0 0-9.748 0l-5.483 5.484c-6.295 6.297-6.295 16.513 0 22.83l.65-5.301a16.55 16.55 0 0 1 4.732-9.689l3.33-3.33a3.15 3.15 0 0 1 4.468 0l4.71 4.711a5.613 5.613 0 0 0 7.94 0 2.894 2.894 0 0 0 0-4.102z"
          fill="url(#oe574fwwfu)"
        />
        <g fill="#EDB25D">
          <path d="m24.223 33.124 16.002-16.005h.02l.934 16.29-3.94 3.96h-.02l-.609-10.643s0-.02-.02 0L24.568 38.77l-.345-5.646" />
          <path d="M46.54 37.938 30.519 53.984l-.934-16.33 3.96-3.961.61 10.683 12.041-12.064z" />
        </g>
      </g>
    </svg>
  );
};

ZoomitTrophy.displayName = 'ZoomitTrophy';
